export const STATUS_LABELS = Object.freeze({
  UNREAD: "읽지 않음",
  READ: "읽음",
  WAITING: "대기",
  WAITING_FOR_REPLAY: "문의 대기",
  WAITING_FOR_REPLY: "문의 대기",
  PENDING: "대기",
  PROCESSING: "처리중",
  ANSWER_COMPLETED: "답변 완료",
  ANSWER_CHECKED: "답변 확인",
  CHECK_THE_ANSWER: "답변 확인",
  COMPLETED: "완료",
  COMPLETE: "완료",
  SUCCESS: "완료",
  CANCELLED: "취소",
  CANCELED: "취소",
  REJECTED: "반려",
  FAILED: "실패",
  FAIL: "실패",
  DELETE: "삭제됨",
  DELETED: "삭제됨",
});

export const normalizeStatusKey = (value) => String(value || "").trim().toUpperCase();

export const getDisplayStatusLabel = (status) => {
  const key = normalizeStatusKey(status);
  return STATUS_LABELS[key] || "확인";
};

export const getDisplayStatusClass = (status) => {
  const key = normalizeStatusKey(status);

  if (key === "UNREAD" || key === "ANSWER_COMPLETED" || key === "PROCESSING") {
    return "is-new";
  }

  if (
    [
      "READ",
      "ANSWER_CHECKED",
      "CHECK_THE_ANSWER",
      "COMPLETED",
      "COMPLETE",
      "SUCCESS",
      "DELETE",
      "DELETED",
      "CANCELLED",
      "CANCELED",
      "REJECTED",
      "FAILED",
      "FAIL",
    ].includes(key)
  ) {
    return "is-read";
  }

  return "is-waiting";
};

export const isUnreadNoteStatus = (status) => normalizeStatusKey(status) === "UNREAD";

export const isCustomerAnswerPendingRead = (status) => normalizeStatusKey(status) === "ANSWER_COMPLETED";
